export default __webpack_public_path__ + "waitingareas.json";